import toast from "react-hot-toast";
import { obtenerDataImagen } from "../../../actions/ImagenAction";
import { base64ToByteArray } from "../../../helpers/tools";
import moment from "moment";
import { adaptVisitaArchivoModelInput } from "../../../data/graphQL/mutations/Visitas/saveArchivoVisita";

export const handleChangeImageVisita = async ({ saveArchivoVisita, name, fileValue, idVisita, handleChange, archivos, idTipoArchivo }) => {
    try {
        await obtenerDataImagen(fileValue).then(async (fileData) => {
            if (!fileData) throw new Error('no hay datos correctos del archivo');

            const parsedFile = {
                contentType: fileData.tipo,
                archivo: base64ToByteArray(fileData.data),
                extension: fileData.extension,
                titulo: fileData.nombre,
                idArchivo: 0,
                idTipoArchivoDocumento: idTipoArchivo,
                idVisita,
                fechaAlta: moment().format('YYYY/MM/DD')
            }

            toast.loading('Guardando archivo...', { id: 'archivo-loading' });

            const res = await saveArchivoVisita({
                variables: {
                    input: adaptVisitaArchivoModelInput(parsedFile)
                }
            });

            toast.dismiss('archivo-loading');

            const newIdArchivo = res?.data?.saveArchivoVisita?.valorEsperado;

            if (!newIdArchivo) throw new Error('No se encontró el id del archivo')

            parsedFile.idArchivo = newIdArchivo;

            handleChange(name, archivos ? [...archivos, parsedFile] : parsedFile);
        });
    } catch (e) {
        toast.dismiss('archivo-loading');
        toast.error('No se pudo cargar el archivo');
    }
}

export const handleChangeSolvedFileVisita = async ({ saveArchivoVisita, name, fileValue, idVisita, handleChange, archivos, idTipoArchivo }) => {
    try {
        const parsedFile = {
            contentType: fileValue.contentType,
            archivo: base64ToByteArray(fileValue.archivo),
            extension: fileValue.extension,
            titulo: fileValue.titulo,
            idArchivo: 0,
            idTipoArchivoDocumento: idTipoArchivo,
            idVisita,
            fechaAlta: moment().format('YYYY/MM/DD')
        }

        toast.loading('Guardando archivo...', { id: 'archivo-loading' });

        const res = await saveArchivoVisita({
            variables: {
                input: adaptVisitaArchivoModelInput(parsedFile)
            }
        });

        toast.dismiss('archivo-loading');

        const newIdArchivo = res?.data?.saveArchivoVisita?.valorEsperado;

        if (!newIdArchivo) throw new Error('No se encontró el id del archivo')

        parsedFile.idArchivo = newIdArchivo;

        handleChange(name, archivos ? [...archivos, parsedFile] : parsedFile);
    } catch (e) {
        toast.dismiss('archivo-loading');
        toast.error('No se pudo cargar el archivo');
    }
}